@if (loading.active()) {
  <div class="loading-bar" role="progressbar" aria-label="Loading">
    <span></span>
  </div>
}
<router-outlet></router-outlet>
<app-drawer></app-drawer>
